import RechargeBg from "../images/recharge-bg.png";
import MemberBg from "../images/member-bg.png";
import MemberBgWide from "../images/member-bg-wide.png";
import RechargeBgWide from "../images/recharge-bg-wide.png";
import MemberBgLargeWide from "../images/member-bg-wide-large.png";
import RechargeBgLargeWide from "../images/recharge-bg-wide-large.png";
import MemberBgDark from "../images/member-bg-dark.png";
import MemberBgWideDark from "../images/member-bg-wide-dark.png";
import MemberBgLargeWideDark from "../images/member-bg-wide-large-dark.png";
import RechargeBgDark from "../images/recharge-bg-dark.png";
import RechargeBgWideDark from "../images/recharge-bg-wide-dark.png";
import RechargeBgLargeWideDark from "../images/recharge-bg-wide-large-dark.png";

import { ChargeType } from ".";

type GlobalStyleProp = {
  bgImage: string;
  bgWideImage: string;
  bgLargeWideImage: string;
  background: string;
  headerActiveClassName: string;
  activityBgField: "lightImageUrl" | "darkImageUrl";
};

export const GlobalStyle: Record<ChargeType, GlobalStyleProp> = {
  [ChargeType.Membership]: {
    bgImage: MemberBg,
    bgWideImage: MemberBgWide,
    bgLargeWideImage: MemberBgLargeWide,
    background: "linear-gradient(360deg, #6B9EEA -14.26%, #3D51BF 61.4%)",
    headerActiveClassName: "left-active-style",
    activityBgField: "lightImageUrl",
  },
  [ChargeType.Recharge]: {
    bgImage: RechargeBg,
    bgWideImage: RechargeBgWide,
    bgLargeWideImage: RechargeBgLargeWide,
    background: "linear-gradient(180deg, #FFFFFF 0%, #DDE7FF 100%",
    headerActiveClassName: "right-active-style",
    activityBgField: "lightImageUrl",
  },
};

export const GlobalDarkStyle: Record<ChargeType, GlobalStyleProp> = {
  [ChargeType.Membership]: {
    bgImage: MemberBgDark,
    bgWideImage: MemberBgWideDark,
    bgLargeWideImage: MemberBgLargeWideDark,
    background: "linear-gradient(180deg, #222E43 0%, #1B2536 100%)",
    headerActiveClassName: "left-active-style",
    activityBgField: "darkImageUrl",
  },
  [ChargeType.Recharge]: {
    bgImage: RechargeBgDark,
    bgWideImage: RechargeBgWideDark,
    bgLargeWideImage: RechargeBgLargeWideDark,
    background: "linear-gradient(180deg, #28364E 0%, #222E44 100%);",
    headerActiveClassName: "right-active-style",
    activityBgField: "darkImageUrl",
  },
};
